<div class="astrea-internal-banner">
    <div class="title">
        <div *ngIf="breadcrumbText && breadcrumLink" class="breadcrumb">
            <div class="d-flex a-i-center j-c-start mb-3">
                <mat-icon>chevron_left</mat-icon>
                <a [routerLink]="[breadcrumLink]" [title]="breadcrumbText">{{ breadcrumbText }}</a>
            </div>
        </div>
        <div class="d-flex j-c-start a-i-center">
            <img
                *ngIf="image"
                class="authorpics mr-2"
                src="{{ image }}"
                alt="{{ title }}"
            >
            <h1>{{ title }}</h1>
        </div>
    </div>
    <img class="img-responsive banner-image" src="/assets/images/banners/internal-banner.png" alt="Banner decorativo de una persona leyendo un libro">
</div>
